import { useIsBenefitEngineAdmin } from "hooks/useBenefitEngineAdmin";
import useDocumentTitle from "hooks/useDocumentTitle";
import { TabPanel, TabView } from "primereact/tabview";

import { LineTypesTab } from "./LineTypesTab";

/**
 * CLE-2792 — Eligibility: the payer-agnostic settings behind every eligibility check.
 *
 * A TABBED page with one tab today. The tab is not decoration: line types are the first of several
 * things that belong to eligibility as a whole rather than to one account or one payer, and giving
 * the first one a page of its own would mean moving it again when the second arrives.
 *
 * ⚠️ VISIBLE TO ONE PERSON while the engine is mid-cutover — see `useBenefitEngineAdmin`. The route
 * is ALSO super-admin protected; this hides a screen, it does not protect an endpoint.
 */
export function EligibilityPage() {
  useDocumentTitle("Eligibility");
  const isEngineAdmin = useIsBenefitEngineAdmin();

  if (!isEngineAdmin) return null;

  return (
    <div className="p-4" data-testid="eligibilityPage">
      <h2 className="m-0 mb-3">Eligibility</h2>
      <TabView data-testid="eligibilityPage.tabs">
        <TabPanel header="Line types">
          <LineTypesTab />
        </TabPanel>
      </TabView>
    </div>
  );
}
